module.exports = __webpack_public_path__ + "assets/img/mrs_logo.f86b94b6.svg";